import styled from "@emotion/styled";

export const Container = styled.div`
  width: 100%;
  max-width: ${p => (p.isBig ? "1370px" : "1228px")};
  padding: 0 ${p => p.theme.space[6]}px;
  margin: 0 auto;

  @media (max-width: ${p => p.theme.screenSizes.lgMin}) {
    ${p => p.isSlider && `padding-right: ${p.theme.space[0]}px;`}
  }
`;
